import { render } from "./SectionsPage.vue?vue&type=template&id=2a30ec19"
import script from "./SectionsPage.vue?vue&type=script&lang=js"
export * from "./SectionsPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__